import React from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { warning } from 'redux/actions/message.action';
import { putObject } from 'redux/actions/s3.action';

/**
 * USAGE: This is an abstract component wrap around a file input that allows user to upload a file to Aws
 *
 <AwsFileUpload
 className='file-upload'
 id='file-upload'
 name='file_upload'
 customStyle={{
      position: 'absolute',
      left: -9999,
      top: -9999
    }}
 fileRef={this.fileRef}
 accept='.png, .jpg, .jpeg, .gif'
 typePattern={/^image\/(png|jpg|jpeg|gif)$/}
 maxSize={5}
 path='userprofile/images/'
 signals={{
      onStart: 'UPLOAD_IMAGE',
      onSuccess: 'UPLOAD_IMAGE_SUCCESS',
      onFailure: 'UPLOAD_IMAGE_FAILED'
    }}
 prefix='avatar_'
 uploadDone={this.UploadDone}
 />
 */

class AwsFileUpload extends React.Component {
  // static defaultProps = {
  //   className: 'file-upload', // Add class to the file input
  //   id='file-upload', // Add id to the file input
  //   name='file_upload', // Add name to the file input
  //   customStyle: {display: none}, // Add custom style to the component
  //   fileRef: {ref}, // ref = React.createRef()
  //   accept: '.png, .jpg, .jpeg, .gif', // Tell browsers to limit the types of files user can choose
  //   typePattern: /^image\/(png|jpg|jpeg|gif)$/, // Check file types (may not need if you use 'accept')
  //   maxSize: 5, // Maximum file size user can upload (in MB)
  //   path: 'users/avatars/', // Folder to store on AWS
  //   signals: {
  //     onStart: 'UPLOAD_IMAGE', // Action to dispatch when a file is chosen
  //     onSuccess: 'UPLOAD_IMAGE_SUCCESS', // Action to dispatch when the file upload has been successful
  //     onFailure: 'UPLOAD_IMAGE_FAILED' // Action to dispatch when the file upload has failed
  //   },
  //   prefix: "avatar_", // Filename prefix
  //   uploadDone: null // Function to run after a file is uploaded, this function receive fileUrl as an argument
  // }

  onFileChange = (e) => {
    const { files } = e.target;
    const props = this.props;

    if (files.length > 0) {
      const file = files[0];

      if (props.typePattern && !props.typePattern.test(file.type))
        return props.warning('Invalid image file (.png, .jpg, .jpeg, .gif)');
      if (props.maxSize && file.size > props.maxSize * 1024 * 1024)
        return props.warning(`File size should <= ${props.maxSize} MB`);

      const params = {
        file: file,
        path: props.path,
        signals: props.signals,
        prefix: props.prefix,
      };

      props.putObject(params, props.uploadDone);
    }
  };

  render() {
    const props = this.props;

    return (
      <input
        type="file"
        ref={props.fileRef}
        className={props.className}
        id={props.id}
        name={props.name}
        accept={props.accept}
        onChange={this.onFileChange}
        style={props.customStyle}
      />
    );
  }
}

AwsFileUpload.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  customStyle: PropTypes.object,
  fileRef: PropTypes.object,
  accept: PropTypes.string,
  typePattern: PropTypes.instanceOf(RegExp),
  maxSize: PropTypes.number,
  path: PropTypes.string.isRequired,
  signals: PropTypes.object.isRequired,
  prefix: PropTypes.string,
  uploadDone: PropTypes.func,
};

const mapDispatchToProps = {
  warning,
  putObject,
};

export default connect(null, mapDispatchToProps)(AwsFileUpload);
